/* tslint:disable */
export const marketColumnsDisplay = {
    "1": {
        maxWidth: 630
    },
    "2": {
        minWidth: 631,
        maxWidth: 735
    },
    "3": {
        minWidth: 736,
        maxWidth: 840
    },
    "4": {
        minWidth: 841,
        maxWidth: 920
    },
    "5": {
        minWidth: 921,
        maxWidth: 1088
    }
};
//# sourceMappingURL=marketColumnsDisplay.js.map